import { render, staticRenderFns } from "./serviceCard.vue?vue&type=template&id=96ba3c86&"
import script from "./serviceCard.vue?vue&type=script&lang=js&"
export * from "./serviceCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports